import { useContext } from "react";
import SpanError from "../../SpanError/SpanError.jsx";
import { FormContext } from "../../../context/FormContext.js";
import InputTextArea from "../../Input/InputTextArea.jsx";

function InputComment({ name, text }) {
  const { handleChange, errors, values } = useContext(FormContext);

  const handleChangeInput = (event) => {
    handleChange(event);
  };

  return (
    <>
      <InputTextArea
        handleChange={handleChangeInput}
        placeholder="Введите сообщение"
        name={name}
        value={text}
      />
      <SpanError message={errors[name]}></SpanError>
    </>
  );
}

export default InputComment;
